import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCrehanaComponent } from './simple-icons-crehana.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCrehanaComponent ],
    exports:      [ SimpleIconsCrehanaComponent ],
    bootstrap:    []
})
export class SimpleIconsCrehanaModule {}
